import React from 'react';

import TitleTv from 'modules/tvpanel/components/TitleTv';
import { TvScreen } from 'entities/TvRender/interfaces';
import TvTable from '../../components/TvTable';

type Props = {
  presentScreen: TvScreen;
};

const ReadyScreen: React.FC<Props> = ({ presentScreen }) => {
  const isDontHaveLp = presentScreen.type === 'location' && presentScreen.licensePlates.length === 0;
  const isPause = presentScreen.type === 'location' && presentScreen.locationId === 0;

  const title = () => {
    if (isDontHaveLp) return '';

    // eslint-disable-next-line
    return isPause ? 'Зверніться на виписку' : 'Приготуватись авто';
  };

  if (presentScreen.type === 'custom') {
    return (
      <div className="h-100 d-flex flex-row align-items-center justify-content-center">
        <div className="h-75">
          <img className="company-logo" src={presentScreen.imageUrl} alt="Кастомний екран" />
        </div>
      </div>
    );
  }
  return (
    <React.Fragment>
      <TitleTv title={title()} />

      {presentScreen.locationId !== 0 && (
        <div id="table" className="d-flex flex-column">
          <TvTable data={presentScreen} />
        </div>
      )}

      {presentScreen.locationId === 0 && (
        <div id="table" className="d-flex flex-column">
          <TvTable data={presentScreen} isDontHaveLp={isDontHaveLp} />
        </div>
      )}
    </React.Fragment>
  );
};

export default ReadyScreen;
